import { getConfigValue } from '../Providers/ConfigsApi';

export default async function GetLowestPricePhotobook() {
  const configKey = 'lowest-price-photobook';

  try {
    const queryString = await getConfigValue(configKey);
    return JSON.parse(queryString);
  } catch (err) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/Common/Helpers/GetLowestPricePhotobook.js